import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the return from Emergent-managed Google login (#session_id=...).
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = (location.hash || '').match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : '';
    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
        setSession(res.data.token, res.data.user);
        toast.success('Welcome back!');
        const u = res.data.user;
        if (u.role === 'driver') navigate('/driver', { replace: true });
        else if (u.role === 'merchant_admin' || u.role === 'merchant_user') navigate('/merchant', { replace: true });
        else navigate('/dashboard', { replace: true });
      } catch (e) {
        const msg = e.response?.data?.detail || 'Google sign-in failed';
        toast.error(msg);
        setError(msg);
        setTimeout(() => navigate('/', { replace: true }), 2800);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-4" data-testid="auth-callback">
      <div className="animate-spin w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full" />
      <p className="text-slate-500 text-sm">{error || 'Signing you in…'}</p>
    </div>
  );
}
